import React, { useEffect, useState } from "react";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import TextArea from "../../../../components/common/TextArea/TextArea";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../../../components/calculator/ConditionLabel/BackButton";
import { ROUTES } from "../../../../constants/Routes";
import StepBar from "../../../../components/calculator/Wizard/StepBar";
import ArrowLeft from ".//..//..//..//..//assets//images//icons//arrow-left.svg";
import Button from "../../../../components/common/buttons/Button";
import DatePickerMat from "../../../../components/common/DatePicker/DatePickerMat";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";
import InputNumbersIntSimple from "../../../../components/common/InputText/InputNumbersIntSimple";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";
import Spinner from "../../../../components/common/Splnner/Spinner";

const KalkulacioLogisztikai = () => {
  const [step, setStep] = useState(5);
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [proposalKey, setProposalKey] = useState("");
  const { getAuth, clearAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");

  const [tarolasi_napok_szama, setTarolasiNapokSzama] = useState(0);
  const [butorlift, setButorlift] = useState(0);
  const [kulso_lift_kezelovel, setKulsoLiftKezelovel] = useState(0);
  const [munkaero, setMunkaero] = useState(0);
  const [munkaeroFinal, setMunkaeroFinal] = useState(0);

  const [villanyszerelo, setVillanyszerelo] = useState(0);
  const [Kuchenmonteur, setKuchenmonteur] = useState(0);
  const [biztositas, setBiztositas] = useState(0);

  // ---
  const [plusz_szolgaltatas, setPluszSzolgaltatas] = useState("");
  const [plusz_szolgaltatas_date, setPluszSzolgaltatasDate] = useState("");
  const [plusz_szolgaltatas_cost, setPluszSzolgaltatasCost] = useState(0);
  const [megjegyzes, setMegjegyzes] = useState("");
  const [pkw, setPkw] = useState(0);
  const [hanger, setHanger] = useState(0);
  const [transport_17, setTransport17] = useState(0);
  const [transport_27, setTransport27] = useState(0);
  const [transport_47, setTransport47] = useState(0);
  const [transport_95, setTransport95] = useState(0);
  const [transport_140, setTransport140] = useState(0);

  // ---
  const [pkw_extra, setPkwExtra] = useState(0);
  const [hanger_extra, setHangerExtra] = useState(0);
  const [transport_17_extra, setTransport17Extra] = useState(0);
  const [transport_27_extra, setTransport27Extra] = useState(0);
  const [transport_47_extra, setTransport47Extra] = useState(0);
  const [transport_95_extra, setTransport95Extra] = useState(0);
  const [transport_140_extra, setTransport140Extra] = useState(0);
  const [total, setTotal] = useState(0);
  const [fahrzeug, setFahrzeug] = useState(0);

  // const [totalCapacity, settotalCapacity] = useState(0);
  // const [totalContainerCapacity, setTotalContainerCapacity] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [notEnoughContainerWarning, setNotEnoughContainerWarning] = useState(false);

  const generateSuggestion = (totals) => {
    const totalCapacity = totals?.totalCapacity;
    console.log(totals);
    // - container suggest
    const suggestedContainers = findSuitableContainer(parseFloat(totalCapacity).toFixed(2));
    setTransport17(suggestedContainers[17]);
    setTransport27(suggestedContainers[27]);
    setTransport47(suggestedContainers[47]);
    setTransport95(suggestedContainers[95]);
    setTransport140(suggestedContainers[140]);
    setFahrzeug(
      17 * suggestedContainers[17] +
        27 * suggestedContainers[27] +
        47 * suggestedContainers[47] +
        95 * suggestedContainers[95] +
        140 * suggestedContainers[140]
    );
  };

  useEffect(() => {
    // pkw
    if (pkw == 0) {
      const pkw = total / 2 > fahrzeug ? 1 : 0;
      setPkw(pkw);
    }
  }, [fahrzeug, total]);

  const generateSuggestion2 = (proposalItems, villanyszerelo, kuchenmonteur, munkaero) => {
    let villanyszereloTotalTime = 0;
    let kuchenmonteurTotalTime = 0;
    let személyzetiTotalTime = 0;

    console.log(proposalItems);
    proposalItems.map((item, index) => {
      if (item?.villanyszerelo == 1) {
        villanyszereloTotalTime +=
          item?.gegenstand * item?.szetszerelesi_ido + item?.gegenstand * item?.osszeszerelesi_ido;
      }
      if (item?.konyhaszerelo == 1) {
        kuchenmonteurTotalTime +=
          item?.gegenstand * item?.szetszerelesi_ido + item?.gegenstand * item?.osszeszerelesi_ido;
      }
      if (item?.konyhaszerelo == 0 && item?.villanyszerelo == 0) {
        személyzetiTotalTime +=
          item?.gegenstand * item?.szetszerelesi_ido + item?.gegenstand * item?.osszeszerelesi_ido;
      }
    });

    if (villanyszereloTotalTime > 6) {
      if (villanyszerelo > 2) {
        setVillanyszerelo(villanyszerelo);
      } else {
        setVillanyszerelo(2);
      }
    } else if (villanyszereloTotalTime > 0) {
      if (villanyszerelo > 1) {
        setVillanyszerelo(villanyszerelo);
      } else {
        setVillanyszerelo(1);
      }
    }
    if (kuchenmonteurTotalTime > 6) {
      if (kuchenmonteur > 2) {
        setKuchenmonteur(kuchenmonteur);
      } else {
        setKuchenmonteur(2);
      }
    } else if (kuchenmonteurTotalTime > 0) {
      if (kuchenmonteur > 1) {
        setKuchenmonteur(kuchenmonteur);
      } else {
        setKuchenmonteur(1);
      }
    }

    if (személyzetiTotalTime > 6) {
      if (munkaero > 2) {
        setMunkaero(munkaero);
      } else {
        setMunkaero(2);
      }
    } else if (személyzetiTotalTime > 0) {
      if (munkaero > 1) {
        setMunkaero(munkaero);
      } else {
        setMunkaero(1);
      }
    }

    console.log(villanyszereloTotalTime, kuchenmonteurTotalTime);
  };
  const fetchLogisticData = () => {
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: `${API_ROUTES.PR_TOURPLAN_LOGISTIC_DATA}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          console.log(data?.data);
          const totals = data?.data?.totals;
          const logisticData = data?.data?.logisticData;
          const proposalData = data?.data?.proposalData;
          const proposalItems = data?.data?.proposalItems;

          const fee = data?.data?.fee;

          console.log(logisticData);
          setProposalKey(proposalData[0]?.proposal_number);
          setTotal(parseFloat(totals?.totalCapacity).toFixed(2));
          setTotalAmount(parseFloat(totals?.totalZwischensum).toFixed(2));
          if (logisticData.length == 0) {
            generateSuggestion(totals);
            generateSuggestion2(proposalItems);
          } else {
            console.log(logisticData[0]?.fahrzeug);
            setTarolasiNapokSzama(logisticData[0]?.tarolasi_napok_szama);
            setButorlift(logisticData[0]?.butorlift);
            setKulsoLiftKezelovel(logisticData[0]?.kulso_lift_kezelovel);
            // setMunkaero(logisticData[0]?.munkaero);
            // setVillanyszerelo(logisticData[0]?.villanyszerelo);
            // setKuchenmonteur(logisticData[0]?.kuchenmonteur);
            setBiztositas(logisticData[0]?.biztositas);
            setPluszSzolgaltatas(logisticData[0]?.plusz_szolgaltatas);
            setPluszSzolgaltatasCost(logisticData[0]?.plusz_szolgaltatas_cost);
            setPluszSzolgaltatasDate(logisticData[0]?.plusz_szolgaltatas_date);
            setMegjegyzes(logisticData[0]?.megjegyzes);
            setPkw(logisticData[0]?.pkw);
            setHanger(logisticData[0]?.hanger);

            setTransport17(logisticData[0]?.transport_17);
            setTransport27(logisticData[0]?.transport_27);
            setTransport47(logisticData[0]?.transport_47);
            setTransport95(logisticData[0]?.transport_95);
            setTransport140(logisticData[0]?.transport_140);
            setPkwExtra(logisticData[0]?.pkw_extra);
            setHangerExtra(logisticData[0]?.hanger_extra);
            setTransport17Extra(logisticData[0]?.transport_17_extra);
            setTransport27Extra(logisticData[0]?.transport_27_extra);
            setTransport47Extra(logisticData[0]?.transport_47_extra);
            setTransport95Extra(logisticData[0]?.transport_95_extra);
            setTransport140Extra(logisticData[0]?.transport_140_extra);
            // setTotal(logisticData[0]?.total);

            setFahrzeug(logisticData[0]?.fahrzeug);

            generateSuggestion2(
              proposalItems,
              logisticData[0]?.villanyszerelo,
              logisticData[0]?.kuchenmonteur,
              logisticData[0]?.munkaero
            );
          }
          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error 1!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Unknown server error 2!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    const totalMunkaero =
      pkw +
      pkw_extra +
      munkaero +
      villanyszerelo +
      Kuchenmonteur +
      transport_17 +
      transport_27 +
      transport_47 +
      transport_95 +
      transport_140 +
      transport_17_extra +
      transport_27_extra +
      transport_47_extra +
      transport_95_extra +
      transport_140_extra;
    setMunkaeroFinal(totalMunkaero);
  }, [
    pkw + pkw_extra,
    munkaero,
    villanyszerelo,
    Kuchenmonteur,
    transport_17,
    transport_27,
    transport_47,
    transport_95,
    transport_140,
    transport_17_extra,
    transport_27_extra,
    transport_47_extra,
    transport_95_extra,
    transport_140_extra,
  ]);
  useEffect(() => {
    const containerCapacity =
      17 * transport_17 + 27 * transport_27 + 47 * transport_47 + 95 * transport_95 + 140 * transport_140;
    setFahrzeug(containerCapacity);
    if (containerCapacity < total) {
      setNotEnoughContainerWarning(true);
    } else {
      setNotEnoughContainerWarning(false);
    }
  }, [transport_17, transport_27, transport_47, transport_95, transport_140]);

  function findSuitableContainer(itemCapacity) {
    const totalItemsCapacity = itemCapacity * 1;
    const boxSizes = [17, 27, 47, 95, 140]; // box sizes in ascending order

    if (itemCapacity <= 0) {
      return {
        17: 0,
        27: 0,
        47: 0,
        95: 0,
        140: 0,
      };
    }

    const boxesRequired = {
      17: 0,
      27: 0,
      47: 0,
      95: 0,
      140: 0,
    };

    // Sort box sizes in descending order to prioritize larger boxes first
    const sortedBoxSizes = boxSizes.slice().sort((a, b) => b - a);

    if (itemCapacity < 17) {
      boxesRequired[17] = 1;
      return boxesRequired;
    } else {
      for (const size of sortedBoxSizes) {
        const numBoxes = Math.floor(itemCapacity / size);

        if (numBoxes > 0) {
          boxesRequired[size] = numBoxes;
          itemCapacity %= size;
        }
      }

      const containerCap = calculateContainerSum(boxesRequired);

      if (totalItemsCapacity > containerCap) {
        const remainCap = totalItemsCapacity - containerCap;

        if (remainCap < 17) {
          boxesRequired[17] = boxesRequired[17] + 1;
        } else if (remainCap < 27) {
          boxesRequired[27] = boxesRequired[27] + 1;
        } else if (remainCap < 47) {
          boxesRequired[47] = boxesRequired[47] + 1;
        } else if (remainCap < 95) {
          boxesRequired[95] = boxesRequired[95] + 1;
        } else if (remainCap < 140) {
          boxesRequired[140] = boxesRequired[140] + 1;
        }
        return boxesRequired;
      } else {
        return boxesRequired;
      }
    }
  }

  function calculateContainerSum(boxCounts) {
    let sum = 0;

    for (const [key, value] of Object.entries(boxCounts)) {
      sum += parseInt(key) * value;
    }

    return sum;
  }

  useEffect(() => {
    fetchLogisticData();
  }, []);

  const saveLogisticData = () => {
    setSpinnerVisible(true);
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_LOGISTIC_DATA_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        tarolasi_napok_szama,
        butorlift,
        kulso_lift_kezelovel,
        munkaero,
        villanyszerelo,
        biztositas,
        plusz_szolgaltatas,
        plusz_szolgaltatas_cost,
        plusz_szolgaltatas_date,
        megjegyzes,
        Kuchenmonteur,
        pkw,
        hanger,
        transport_17,
        transport_27,
        transport_47,
        transport_95,
        transport_140,
        pkw_extra,
        hanger_extra,
        transport_17_extra,
        transport_27_extra,
        transport_47_extra,
        transport_95_extra,
        transport_140_extra,
        total,
        fahrzeug,
        megjegyzes,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setSpinnerVisible(false);
          toast.success("Útvonalterv információ sikeresen frissítve", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_MANAGE_SUMMARY}?p-id=${proposalId}`);
        } else if (res.status === 422) {
          const messages = res.message;
          console.log(messages);
          setSpinnerVisible(false);
          toast.error("Hiba, az útvonalterv információja nem frissült", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          setSpinnerVisible(false);
          navigator(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        console.log(error);
        setSpinnerVisible(false);
        toast.error("Hiba, az útvonalterv információja nem frissült", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <Spinner spinnerVisible={spinnerVisible}>
        <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem] gap-3 grid grid-cols-2 md:grid-cols-[10rem_1fr_10rem] grid-rows-2 md:grid-rows-1">
          <div className="col-start-1 col-end-2 row-start-2 row-end-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] me-auto">
              <Link to={`${ROUTES.CAL_MANAGE_ITEM_LIST}?p-id=${proposalId}`}>
                <BackButton icon={ArrowLeft} label={"Vissza"} />
              </Link>
            </div>
          </div>
          <div className="w-full col-span-2 md:col-span-1 md:col-end-3 md:col-start-2 ">
            <StepBar currentStepNo={step} />
          </div>
          <div className="col-start-2 col-end-3 row-start-2 row-end-3 md:col-end-4 md:col-start-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] ms-auto">
              {/* <Link to={ROUTES.CAL_MANAGE_SUMMARY}> */}
              <Button label={"Mentés"} onClick={saveLogisticData} />
              {/* </Link> */}
            </div>
          </div>
        </div>
        <div className="px-[1rem] sm:px-[1.875rem] mt-[3.7rem] flex flex-col sm:items-center justify-between sm:flex-row gap-10">
          <div className="flex flex-row items-center justify-between gap-[1.5rem] w-full">
            <div className="flex flex-col">
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[2rem] font-bold leading-[2.5rem]">
                Ajánlat száma: {proposalKey}
              </span>
            </div>
            <div className="flex flex-row gap-10">
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[1.5rem] font-bold leading-[2.5rem]">
                Összesen: {totalAmount} EUR
              </span>
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[1.5rem] font-bold leading-[2.5rem]">
                Köbméter: {total} m3
              </span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-[3.75rem] lg:grid-cols-2 px-[1rem] sm:px-[1.875rem] mt-[3.75rem]">
          {/* Left Side Start */}
          <div>
            <div className="p-5 border-2 border-secondary-color rounded-xl bg-[#0655671a]">
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Tárolási napok száma
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">
                    A korábban megadott eszközökre vonatkozóan
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"tarolasi_napok_szama"}
                    name={"tarolasi_napok_szama"}
                    value={tarolasi_napok_szama}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setTarolasiNapokSzama(0);
                      } else {
                        setTarolasiNapokSzama(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Bútorlift
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">
                    Hány órát fogod használni? (minimum 4 óra)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"butorlift"}
                    name={"butorlift"}
                    value={butorlift}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setButorlift(0);
                      } else {
                        setButorlift(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Külső lift kezelővel
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">
                    Hány órát fogod használni? (minimum 4 óra)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"kulso_lift_kezelovel"}
                    name={"kulso_lift_kezelovel"}
                    value={kulso_lift_kezelovel}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setKulsoLiftKezelovel(0);
                      } else {
                        setKulsoLiftKezelovel(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Munkaerő
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">
                    Hány főre van szükség a munkához?
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"munkaero"}
                    name={"munkaero"}
                    value={munkaeroFinal}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setMunkaero(0);
                      } else {
                        setMunkaero(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Villanyszerelő
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">Hány főre van szükség?</span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"villanyszerelo"}
                    name={"villanyszerelo"}
                    value={villanyszerelo}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setVillanyszerelo(0);
                      } else {
                        setVillanyszerelo(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Küchenmonteur
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">
                    Hány főre van Küchenmonteur?
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"Küchenmonteur"}
                    name={"Küchenmonteur"}
                    value={Kuchenmonteur}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setKuchenmonteur(0);
                      } else {
                        setKuchenmonteur(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex flex-col">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Biztosítás
                  </span>
                  <span className="font-normal font-lato text-[0.75rem] leading-normal">
                    Szeretne az ügyfél biztosítást?
                  </span>
                </div>
                <div className="flex items-center justify-center w-full">
                  <CheckBoxWithOutLabel
                    checked={biztositas == 1 ? true : false}
                    onClick={() => setBiztositas(!biztositas)}
                  />
                </div>
              </div>
              {/*  */}
            </div>
          </div>
          <div
            className={`p-5 border-2 rounded-xl ${
              notEnoughContainerWarning === false ? "bg-[#EAEBEA]" : "bg-[#ffd2d2]"
            }`}
          >
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">PKW</span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"pkw"}
                  name={"pkw"}
                  value={pkw}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setPkw(0);
                    } else {
                      setPkw(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                  Hänger (m³)
                </span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"hanger"}
                  name={"hanger"}
                  value={hanger}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setHanger(0);
                    } else {
                      setHanger(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                  Transport {`<`}17m³ (3,5 to)
                </span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"transport_17"}
                  name={"transport_17"}
                  value={transport_17}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setTransport17(0);
                    } else {
                      setTransport17(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                  Transport {`<`}27m³ (7,5 to)
                </span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"transport_27"}
                  name={"transport_27"}
                  value={transport_27}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setTransport27(0);
                    } else {
                      setTransport27(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                  Transport {`<`}47m³ (18 to und WB)
                </span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"transport_47"}
                  name={"transport_47"}
                  value={transport_47}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setTransport47(0);
                    } else {
                      setTransport47(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                  Transport {`<`}95m³ (18 to + Hänger)
                </span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"transport_95"}
                  name={"transport_95"}
                  value={transport_95}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setTransport95(0);
                    } else {
                      setTransport95(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-[1fr_100px]">
              <div className="flex items-center">
                <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                  Transport {`<`}140m³ (2x 18 to + 1 x Hänger)
                </span>
              </div>
              <div className="p-1 ">
                <InputNumbersIntSimple
                  id={"transport_140"}
                  name={"transport_140"}
                  value={transport_140}
                  onChange={(e) => {
                    if (e.target.value.trim().length == 0) {
                      setTransport140(0);
                    } else {
                      setTransport140(parseInt(e.target.value));
                    }
                  }}
                />
              </div>
            </div>
            {/*  */}
          </div>
        </div>
        <div className="grid grid-cols-1 gap-[3.75rem] lg:grid-cols-2 px-[1rem] sm:px-[1.875rem] ">
          <div className="">
            <div className="mt-[3.75rem] mb-4">Plusz szolgáltatás hozzáadása</div>
            <div className="grid gap-10 grid-cols-[1fr_140px]">
              <InputTextSimple
                id={"plusz_szolgaltatas"}
                name={"plusz_szolgaltatas"}
                value={plusz_szolgaltatas}
                onChange={(e) => {
                  setPluszSzolgaltatas(e.target.value);
                }}
              />
              <div className="flex items-center gap-[0.675rem] ">
                <InputNumbersSimple
                  id={"plusz_szolgaltatas_cost"}
                  name={"plusz_szolgaltatas_cost"}
                  value={plusz_szolgaltatas_cost}
                  onChange={(e) => {
                    console.log(typeof e.target.value);
                    setPluszSzolgaltatasCost(e.target.value);
                  }}
                />
                EUR
              </div>
            </div>
          </div>
          <div>
            <div className="mt-[1rem] grid gap-10 grid-cols-[1fr_140px] text-[1.5rem] font-bold leading-normal font-lato text-text-primary-color">
              <span className="text-end">TOTAL m³:</span>
              <div className="text-end ">{total}</div>
            </div>
            <div className="mt-[1rem] grid gap-10 grid-cols-[1fr_140px] text-[1.5rem] font-bold leading-normal font-lato text-text-primary-color">
              <span className="text-end">Fahrzeug m³:</span>
              <div className="text-end text-[#AB3C1B]">{parseFloat(fahrzeug).toFixed(2)}</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-[3.75rem] mt-[3.75rem]  lg:grid-cols-2 px-[1rem] sm:px-[1.875rem] ">
          <div className="mt-5">
            <div className="mb-4 ">Plusz szolgáltatás hozzáadása</div>
            <DatePickerMat
              label={`Date`}
              defaultValue={{
                startDate: plusz_szolgaltatas_date,
                endDate: plusz_szolgaltatas_date,
              }}
              onChange={(e) => {
                console.log(e);
                setPluszSzolgaltatasDate(e.startDate);
              }}
            />
          </div>
          <div>
            {/*  */}
            <div className="mb-4 ">Extra jármű szükséglet</div>
            <div className="p-5 border-2 rounded-xl bg-[#EAEBEA]">
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    PKW
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"pkw_extra"}
                    name={"pkw_extra"}
                    value={pkw_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setPkwExtra(0);
                      } else {
                        setPkwExtra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Hänger (m³)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"hanger_extra"}
                    name={"hanger_extra"}
                    value={hanger_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setHangerExtra(0);
                      } else {
                        setHangerExtra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Transport {`<`}17m³ (3,5 to)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"transport_17_extra"}
                    name={"transport_17_extra"}
                    value={transport_17_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setTransport17Extra(0);
                      } else {
                        setTransport17Extra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Transport {`<`}27m³ (7,5 to)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"transport_27_extra"}
                    name={"transport_27_extra"}
                    value={transport_27_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setTransport27Extra(0);
                      } else {
                        setTransport27Extra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Transport {`<`}47m³ (18 to und WB)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"transport_47_extra"}
                    name={"transport_47_extra"}
                    value={transport_47_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setTransport47Extra(0);
                      } else {
                        setTransport47Extra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Transport {`<`}95m³ (18 to + Hänger)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"transport_95_extra"}
                    name={"transport_95_extra"}
                    value={transport_95_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setTransport95Extra(0);
                      } else {
                        setTransport95Extra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
              <div className="grid grid-cols-[1fr_100px]">
                <div className="flex items-center">
                  <span className="font-lato text-[1.125rem] font-bold text-text-primary-color leading-normal">
                    Transport {`<`}140m³ (2x 18 to + 1 x Hänger)
                  </span>
                </div>
                <div className="p-1 ">
                  <InputNumbersIntSimple
                    id={"transport_140_extra"}
                    name={"transport_140_extra"}
                    value={transport_140_extra}
                    onChange={(e) => {
                      if (e.target.value.trim().length == 0) {
                        setTransport140Extra(0);
                      } else {
                        setTransport140Extra(parseInt(e.target.value));
                      }
                    }}
                  />
                </div>
              </div>
              {/*  */}
            </div>

            <div className="mt-[3.75rem] mb-4 ">Megjegyzés</div>
            <TextArea
              placeholder={`Kezd el gépeni a feljegyzést...`}
              value={megjegyzes}
              id={"megjegyzes"}
              name={"megjegyzes"}
              onChange={(e) => setMegjegyzes(e.target.value)}
            />
          </div>
        </div>

        {/* Right Side Start */}
      </Spinner>
    </>
  );
};

export default KalkulacioLogisztikai;
